import { FormView } from "../FormView";

export function ApplicationPage() {
  return <FormView formId="job-application" />;
}
